import { usePostData } from '../lib/hooks/requests';
import { changePasswordUrl } from '../lib/paths';

export const useChangePassword = () => {
  return usePostData(changePasswordUrl);
};
